import React, { forwardRef } from 'react';

import './linked-textarea.scss';

export const LinkedTextarea = forwardRef(
  (
    {
      label,
      name,
      value,
      placeholder,
      onChange,
      onFocus,
      required = false,
      filled = false,
      bordered = false,
      style,
      rows = 4,
      linkedValue,
      linkedLabel,
      error,
      display = false,
      isLinked
    },
    ref
  ) => {
    const handleCheckboxToggle = () => {
      const newLinkedState = !isLinked;
      const newValue = newLinkedState ? linkedValue : value;

      if (onChange) {
        onChange({ value: newValue, isLinked: newLinkedState });
      }
    };

    const handleTextareaChange = (event) => {
      const updatedValue = event.target.value;
      const newLinkedState = false;

      if (onChange) {
        onChange({ value: updatedValue, isLinked: newLinkedState });
      }
    };

    const displayValue = isLinked ? (linkedValue ?? '') : (value ?? '');
    const isReadOnly = isLinked || display;

    const textareaClassName = `
      ${isReadOnly ? 'textarea--disabled' : ''}
    `;

    return (
      <div
        className={`linked-textarea${filled ? ' linked-textarea--filled' : ''}${bordered ? ' linked-textarea--bordered' : ''} 
        ${!!error ? 'linked-textarea--error' : ''}`}
        style={style}
      >
        <div className="linked-textarea__header">
          {label && (
            <label htmlFor={name}>
              {label}
              {required && !display && <span> *</span>}
            </label>
          )}
          <label className="linked-textarea__checkbox">
            <input
              type="checkbox"
              checked={isLinked}
              onChange={handleCheckboxToggle}
              disabled={display}
            />
            {linkedLabel}
          </label>
        </div>

        <textarea
          ref={ref}
          id={name}
          name={name}
          rows={rows}
          value={displayValue}
          placeholder={placeholder}
          onChange={handleTextareaChange}
          onFocus={onFocus}
          readOnly={isReadOnly}
          className={textareaClassName}
        />
      </div>
    );
  }
);
